import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class WebMenuService extends Service {
    constructor() {
        super();
        this.baseURL = 'product/webmenu';
    }

    async findParents() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/all/parent", {
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json', }
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findAllSubMenus() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/all/hassubmenu", {
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json', }
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findSubMenusByParentId(parentId, offset = 0, limit = 30, barcode = null, hasImage = null) {
        let url = `${SERVER_URL}${this.baseURL}/all/menu/sub/${parentId}?offset=${offset}&limit=${limit}`;

        // 🔹 barcode varsa ekle
        if (barcode) {
            url += `&barcode=${encodeURIComponent(barcode)}`;
        }

        // 🔹 hasImage null değilse ekle
        if (hasImage !== null && hasImage !== undefined) {
            url += `&hasImage=${hasImage}`;
        }

        try {
            const response = await GeneralUtils.fetchWithAuth(url, {
                headers: {
                    'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            GeneralUtils.notification(error.message || error);
            return [];
        }
    }


    async addItemToWebMenu(parentId, productId,grpMainId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/item/add/"+ parentId + "/" + productId + "/" + grpMainId  , {
            crossDomain: true,
            method: 'put',
            headers: {
                'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async updateWebMenuDisplay(data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/display", {
            crossDomain: true,
            method: 'put',
            headers: {
                'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async transfer() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/transfer", {
            crossDomain: true,
            method: 'put',
            headers: {
                'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }



}